export function getDatetimeYear(datetime: string): string {
  return new Date(datetime).getFullYear().toString();
}

export function calculateEconomicCarbonIntensity(
  carbon: number,
  turnover: number
): number {
  return carbon / (turnover / 100000.0);
}

export function calculateSocialCarbonIntensity(
  carbon: number,
  employees: number
): number {
  return carbon / employees;
}
